import {
  BodyDark,
  Loading,
  Pressable,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  TableSection,
} from '@/components/elements';
import { Comment } from '@roc-digital/types';
import React from 'react';
import { Link } from './Link';

export interface CommentListProps {
  comments: Comment[];
  loading?: boolean;
  onEdit?: (block: Comment) => void;
}

export function CommentList(props: CommentListProps) {

  const loading = props.loading;

  return (
    <>
      <Table>
        <TableSection type="head">
          <TableRow>
            <TableHeader className={'min-w-[120px]'}>Date</TableHeader>
            <TableHeader className={'w-1/5'}>From</TableHeader>
            <TableHeader className={'w-3/5'}>Comment</TableHeader>
            <TableHeader className={'w-2/5'}>Article</TableHeader>
            <TableHeader className={''}></TableHeader>
          </TableRow>
        </TableSection>
        <TableSection>
          {props.comments.map((comment, index) => (
            <React.Fragment key={comment.id}>
              <TableRow>
                <TableCell className={''}>
                  <BodyDark>{new Date(comment.timestamp * 1000).toLocaleString()}</BodyDark>
                </TableCell>
                <TableCell className={''}>
                  <Link to={`/users/${comment.user_id}`}>{comment.handle}</Link>
                </TableCell>
                <TableCell className={''}>
                  <BodyDark>{comment.body}</BodyDark>
                </TableCell>
                <TableCell className={''}>
                  <Link to={`/articles/${comment.ref_id}/preview`}>{comment._article_title || '(No Title)'}</Link>
                </TableCell>
                <TableCell className={'text-right'}>
                  {props.onEdit ? <>
                    <Pressable className={'inline mx-2'} clickEvent={() => props.onEdit?.(comment)}>
                      <img src={'/icons/edit_zone.svg'} title={'Edit'} className={'inline h-5'} />
                    </Pressable>
                  </> : null}
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
          {!loading && props.comments.length === 0 ? (
            <TableRow>
              <TableCell className={'text-center'} colSpan={6}>
                <div className={'p-2'}>No comments found.</div>
              </TableCell>
            </TableRow>
          ) : null}
          {loading ? (
            <TableRow>
              <TableCell className={'text-center'} colSpan={2}>
                <Loading size={'medium'} />
              </TableCell>
            </TableRow>
          ) : null}
        </TableSection>
      </Table>
    </>
  );
};
